package com.arenaproplay.admin.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.arenaproplay.admin.navigation.Routes
import com.arenaproplay.admin.ui.utils.encodeQueryValue
import com.arenaproplay.admin.ui.utils.urlParam

/**
 * Legacy /audit-log route — redirects to /system?tab=audit.
 *
 * Content has fully moved to the «Аудит» tab of SystemPage (R8).
 *
 * URL param mapping:
 *   ?q=…      → forwarded as ?q=…
 *   ?offset=… → forwarded as ?offset=…
 */
@Page("/audit-log")
@Composable
fun AuditLogPage() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        val params = buildString {
            val q = urlParam("q")?.ifBlank { null }
            val offset = urlParam("offset")?.ifBlank { null }
            if (q != null) append("&q=${encodeQueryValue(q)}")
            if (offset != null) append("&offset=${encodeQueryValue(offset)}")
        }
        ctx.router.navigateTo("${Routes.SYSTEM}?tab=audit$params")
    }
}
